<div class="row">


    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <mat-card>
            <button mat-raised-button (click)="ajouterNouveau(true)" color="primary">
                <mat-icon>add</mat-icon>Ajouter Carte visite
            </button>
            <button mat-raised-button (click)="ajouterNouveau(false)" color="secondary">
                <mat-icon>add</mat-icon>Ajouter EMail
            </button>
            <div class="table-container mat-elevation-z8" style="    height: 80%;
            overflow: auto;">
                <table mat-table #table [dataSource]="dataSource"
                    style="width: 100%;height: 200px!important;overflow: scroll;">
                    <ng-container matColumnDef="nom">
                        <th mat-header-cell *matHeaderCellDef style="width: 40%;"> Nom </th>
                        <td mat-cell *matCellDef="let row"> {{row.nom}}


                        </td>
                    </ng-container>

                    <ng-container matColumnDef="mobile">
                        <th mat-header-cell *matHeaderCellDef style="width: 20%;"> Mobile </th>
                        <td mat-cell *matCellDef="let row"> {{row.mobile}} </td>
                    </ng-container>
                    <ng-container matColumnDef="role">
                        <th mat-header-cell *matHeaderCellDef style="width: 20%;"> Role </th>
                        <td mat-cell *matCellDef="let row"> {{role(row.typeContact)}} </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="width: 20%;"> Action </th>
                        <td mat-cell *matCellDef="let row">


                            <button class="ui-button-danger" pButton (click)="deleteContact(row)" icon="pi pi-trash"
                                style="margin-right: .5em">

                            </button>
                            <button pButton type="button" class="btn-def" icon="pi pi-pencil" (click)="select(row)">

                            </button>




                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['nom','mobile','role','action']"></tr>
                    <tr (click)="select(row)" style="cursor: pointer;"
                        [ngStyle]="{'background-color':selectedClient.contact && selectedClient.contact.contactId===row.contactId ? '#E0F2FD' : '','font-weight':selectedContact && selectedContact.contactId===row.contactId ? 'bolder' : '' }"
                        mat-row *matRowDef="let row; columns: ['nom','mobile','role','action'];"></tr>
                </table>
            </div>



        </mat-card>
    </div>

    <div *ngIf="selectedContact" class="col-xs-6 col-sm-6 col-md-6 col-lg-6">


        <mat-card>

            <div class="d-flex flex-row-reverse">
                <button class="btn btn-danger" *ngIf="showSave" (click)="editContact()">Sauvgarder</button>
            </div>
            <form [formGroup]="form">
                <mat-form-field style="width:50% ;float: left;;margin-right: 5px;">
                    <input matInput placeholder="Nom" formControlName="nom" required>
                </mat-form-field>

                <button (click)="setAsPrincipal()" mat-button>Set As principal</button>



                <mat-form-field style="width: 20% ;float: left;;">
                    <mat-label>Role du contact</mat-label>
                    <mat-select formControlName="typeContact">

                        <mat-option value="signataire">Signataire</mat-option>
                        <mat-option value="gestionnaire">Gestionnaire du dossier</mat-option>
                        <mat-option value="cartevisite">Carte Visite</mat-option>
                        <mat-option value="email">Email</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <input matInput placeholder="E-Mail" type="mail" formControlName="mail" required>
                </mat-form-field>
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Mobile" formControlName="mobile" required>
                </mat-form-field>
                <div *ngIf="selectedContact.typeContact!=='email'">

                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Telephone" type="text" formControlName="tel" required>
                    </mat-form-field>


                    <mat-form-field *ngIf="selectedContact" floatPlaceholder="always">
                        <input matInput placeholder="Position" [matAutocomplete]="autocompleteTemplateRefId"
                            formControlName="titres" (ngModelChange)="filterPositions(selectedContact.titres)">
                    </mat-form-field>

                    <mat-autocomplete #autocompleteTemplateRefId="matAutocomplete">
                        <mat-option *ngFor="let position of positionsS" [value]="position">
                            {{position}}
                        </mat-option>
                    </mat-autocomplete>
                </div>


            </form>
        </mat-card>
    </div>



</div>